/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SolicitarCancelamentoAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AUTOCOMPLETE_1 = 'autocomplete-1',
  AUTOCOMPLETE_2 = 'autocomplete-2',
  CHECKBOX_0 = 'checkbox-0',
  CHECKLIST = 'checklist',
  CONTEXTUAL_BAR = 'contextual-bar',
  FETCH_0 = 'fetch-0',
  FETCH_2 = 'fetch-2',
  FETCH_3 = 'fetch-3',
  FETCH_BENEFICIARIOS_RESCISAO = 'fetch-beneficiarios-rescisao',
  FETCH_FINANCEIRO = 'fetch-financeiro',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_13 = 'field-13',
  FIELD_BENEFICIARIOS = 'field-beneficiarios',
  FIELD_FIN_AGENCIA = 'field-fin-agencia',
  FIELD_FIN_AGENCIA_DIGITO = 'field-fin-agencia-digito',
  FIELD_FIN_BANCO = 'field-fin-banco',
  FIELD_FIN_CONTA = 'field-fin-conta',
  FIELD_FIN_CONTA_DIGITO = 'field-fin-conta-digito',
  FIELD_FIN_CPF = 'field-fin-cpf',
  FIELD_FIN_PAGADOR = 'field-fin-pagador',
  FIELD_LIST_0 = 'field-list-0',
  FIELD_NOVO_TITULAR = 'field-novo-titular',
  FIELD_NUMERO_CPF = 'field-numero-cpf',
  FIELD_TERMO = 'field-termo',
  FIELDSET_BENEFICIARIOS = 'fieldset-beneficiarios',
  FIELDSET_BENEFICIARIOS_CHECKLIST = 'fieldset-beneficiarios-checklist',
  FIELDSET_FINANCEIRO = 'fieldset-financeiro',
  FIELDSET_TITULAR = 'fieldset-titular',
  FORM_BENEFICIARIOS = 'form-beneficiarios',
  FORM_FINANCEIRO = 'form-financeiro',
  FORM_INFORMACOES = 'form-informacoes',
  FORM_TITULAR = 'form-titular',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  INPUT_3 = 'input-3',
  INPUT_4 = 'input-4',
  INPUT_5 = 'input-5',
  INPUT_6 = 'input-6',
  INPUT_NUMERO_CPF = 'input-numero-cpf',
  LAYOUT_SOLICITAR_CANCELAMENTO = 'layout-solicitar-cancelamento',
  LINK_TERMOS = 'link-termos',
  LOADER_0 = 'loader-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  MAPPER_2 = 'mapper-2',
  PANEL_CARD = 'panel-card',
  PANEL_FINANCEIRO = 'panel-financeiro',
  PANEL_LOADER = 'panel-loader',
  PANEL_TITULAR = 'panel-titular',
  PANEL_WIZARD = 'panel-wizard',
  PHONE_NUMBER_0 = 'phone-number-0',
  PHONE_NUMBER_1 = 'phone-number-1',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TOAST_NOTIFICATION_0 = 'toast-notification-0',
  TOAST_NOTIFICATION_1 = 'toast-notification-1',
  TOAST_NOTIFICATION_2 = 'toast-notification-2',
  WIZARD = 'wizard',
  WIZARD_STEP_0 = 'wizard-step-0',
  WIZARD_STEP_1 = 'wizard-step-1',
  WIZARD_STEP_2 = 'wizard-step-2',
  WIZARD_STEP_3 = 'wizard-step-3',
}
export { SolicitarCancelamentoAliases };
